export const rules = {
    email: [
        { required: true, message: 'Please input your Email!' }
    ],
    password: [
        { required: true, message: 'Please input your password!' },
        { min: 6, message: "password no less than 6" },
    ],
};